commusoftCommon.directive("smartpostcodeform", function($http, $timeout, $rootScope, postCodeHelper, panelValidationHelper, prefix) {
    var handleSmartPostCode = function handleSmartPostCode(scope, element, attrs) {
        /*==========================================================================================
         Initial Variables
         ==========================================================================================*/
        scope.address_matches = [];
        scope.data_arrived = false;
        scope.search_fulladdress = false;
        scope.just_postcode = attrs.justPostcode || false;

        scope.formatted_postcode = angular.uppercase(attrs.postcode);

        /*==========================================================================================
         Find address with the entered postcode
         ==========================================================================================*/
        scope.lookUpAddress = function lookUpAddress() {
            scope.$emit('smartpostcode:loading', true);
            $http.get(prefix + '/search_postcode?postcode=' + scope.formatted_postcode).then(function(data) {
                scope.$emit('smartpostcode:loading', false);
                // TODO: Handle Errors from Backend
                scope.address_matches = data.data.address;
                scope.data_arrived = true;

                scope.$emit('smartpostcode:addresses_list_arrived', data.data.address)
            });
        }

        scope.handleAddress = function handleAddress(chosenAddress) {
            scope.selected_address = chosenAddress;
            scope.$emit('smartpostcode:addressSelected', scope.selected_address);
        }

        scope.useAddress = function useAddress() {
            scope.$emit('smartpostcode:address', {
                'addressLine1': scope.selected_address['addressLine1'],
                'addressLine2': scope.selected_address['addressLine2'],
                'addressLine3': scope.selected_address['addressLine3'],
                'town'  : scope.selected_address['city'],
                'county': scope.selected_address['county'],
                'postcode': scope.selected_address['postcode']
            });
        }

        $rootScope.$$listeners['smartpostcode:use_address'] = [];	// Reinit the listeners
        $rootScope.$on('smartpostcode:use_address', function(e) {
            scope.useAddress();
        })

        var initialise = (function() {
            scope.lookUpAddress();
        })();
    }

    return {
        restrict: 'A',
        scope: {},
        templateUrl: '/template/shared/smart_postcode_form.html',
        link: handleSmartPostCode
    }
});
